// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'

// Plugins
import './plugins'

// Components
import './components'

//Customs for the project
import './custom'

// Sync router with store
import {sync} from 'vuex-router-sync'

// Application imports
import App from './App'
import i18n from './i18n'
import router from './router'
import store from './store'
// TODO: Install vee validate
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);
Vue.config.productionTip = false;

// Sync store with router
sync(store, router);

Vue.config.productionTip = false;
import moment from 'moment'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel);

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY H:mm')
    }
});

Vue.filter('filterByName', function (data, input) {
    if(input){
        return data.filter(function (item) {
            // we check if the item starts with
            return item.name.startsWith(input);
        });
    }
    return data
});

import IdleVue from 'idle-vue'

const eventsHub = new Vue();

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 40000
});
import vuetify from './plugins/vuetify';
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    i18n,
    router,
    store,
    vuetify,
    onIdle() {
        console.log("IDLE USER");
        if (
            !this.$route.path.includes('/c-panel/staff') &&
            !this.$route.path.includes('/c-panel/admin') &&
            this.$route.path.includes('/c-panel')
        ) {
            console.log('redirect idle user');
            this.$router.push({path: '/c-panel/staff'});
        }
    },
    render: h => h(App)
}).$mount('#app');

